export default __webpack_public_path__ + "static/Login-banner-2x-d7dd512e58fbb916ea936da9f03a35e3.png";